import { getDateFromDateInTimeZone } from '@jbhi-fi/utils/src/date/getDateFromDateInTimeZone';

export const getSalesLineHours = () => {
  // The values for sales line hours are entered in Melbourne or Auckland time
  const timeZone = (() => {
    switch (window.Jbhifi.storeLocation) {
      case 'AU':
        return 'Australia/Melbourne';
      case 'NZ':
        return 'Pacific/Auckland';
    }
  })();

  const dayOfWeek = new Date().getDay();
  const hours = (window.Jbhifi.jbSalesLineHours?.[dayOfWeek] ?? [])
    .map(timeString => timeString.trim().padStart(4, '0'))
    .map(timeString => {
      return { hour: parseInt(timeString.slice(0, 2), 10), minute: parseInt(timeString.slice(2, 4), 10) };
    })
    .map(({ hour }) => getDateFromDateInTimeZone({ hour, timeZone }))
    .filter(datetime => Boolean(datetime))
    .map(datetime =>
      Intl.DateTimeFormat('en-AU', { hour: 'numeric', hourCycle: 'h12' }).format(datetime).replace(' ', '')
    );

  if (hours.length !== 2) return undefined;

  return `${hours[0]}–${hours[1]}`;
};
